import { useCallback } from 'react';
import type { CaretCsvHandler } from '@shared/csv/use-caret-utils';

export interface UseCaretCsvOptions<T> {
    items: T[];
    onImport: (items: T[]) => void;
    exportFileName?: string;
}

export const useCaretCsv = <T>(handler: CaretCsvHandler<T>, options: UseCaretCsvOptions<T>) => {
    const { items, onImport, exportFileName } = options;

    const importFromFile = useCallback(
        async (file: File) => {
            const imported = await handler.readFromFile(file, items);
            if (imported.length > 0) {
                onImport(imported);
            }
            return imported.length;
        },
        [handler, items, onImport],
    );

    const exportToFile = useCallback(() => {
        handler.download(items, exportFileName);
    }, [handler, items, exportFileName]);

    const exportTemplate = useCallback(() => {
        handler.downloadTemplate();
    }, [handler]);

    return {
        importFromFile,
        exportToFile,
        exportTemplate,
    };
};
